import { useState, useEffect } from 'react';
import { Channel } from 'pusher-js';
import { useAppContext } from '@context/appContext';

interface UseCaptionsReadyProps {
  shareId: string;
  // True while the video has no captions yet.
  isAwaitingCaptions: boolean;
}

export const useCaptionsReady = ({
  shareId,
  isAwaitingCaptions,
}: UseCaptionsReadyProps) => {
  const [captionsReady, setCaptionsReady] = useState<Channel | undefined>(
    undefined
  );
  const { getPusher } = useAppContext();

  useEffect(() => {
    if (!isAwaitingCaptions || !shareId) return undefined;

    const pusher = getPusher();
    const channelName = `captions-ready-${shareId}`;
    const channel = pusher?.subscribe(channelName);
    setCaptionsReady(channel);

    return () => {
      // Unsubscribe only this channel by name. `Channel` has no `disconnect()`,
      // and tearing down the shared Pusher connection here would break other
      // subscriptions (Pusher is shared via AppContext).
      pusher?.unsubscribe(channelName);
      setCaptionsReady(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shareId]);

  return { captionsReady };
};
